import { forwardRef } from 'react'
import { NumericFormat } from 'react-number-format'

import { Lock } from '../../icons/lock'
import type { TextInputProps } from '../text-input'
import { TextInput } from '../text-input'
import styles from './ssn-input.module.scss'
import { iconSizeSmall, iconSizeXSmall } from '@styles/variables'

export const SSN_LENGTH = 4

/**
 * Lets you input last 4 ssn digits.
 */
export const SsnInput = forwardRef<HTMLInputElement, SsnInputProps>(
    ({ size, onChange, placeholder = 'xxxx', ...restOfProps }, ref) => (
        <NumericFormat
            {...restOfProps}
            size={size}
            type='text'
            getInputRef={ref}
            allowLeadingZeros
            placeholder={placeholder}
            customInput={TextInput}
            maxLength={SSN_LENGTH}
            minLength={SSN_LENGTH}
            className={styles.input}
            onChange={(e: any) => {
                onChange?.(e)
                if (e.target.value.length === SSN_LENGTH) e.target.blur()
            }}
            adornment={{
                left: (
                    <div className={styles.prefix}>
                        XXX&nbsp;-&nbsp;XX&nbsp;-&nbsp;
                    </div>
                ),
                right: (
                    <Lock
                        color='step-cold-steel'
                        width={iconSizeXSmall}
                        height={iconSizeSmall}
                    />
                ),
            }}
        />
    ),
)

export type SsnInputProps = Omit<TextInputProps, 'type'>
